module.exports = __webpack_public_path__ + "static/media/5.b878720f.webp";